export default __webpack_public_path__ + "static/earth-8b30430cd9b49c218b6c40204196fb30.svg";